/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SalesInputs */

const id_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon`)
};

const ms_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jualan`)
};

const da_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udsalg`)
};

const de_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote`)
};

const en_us2_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales`)
};

const es_es2_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebajas`)
};

const es_mx2_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const fil_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Sale`)
};

const fr_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotions`)
};

const it_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconti`)
};

const hu_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akciók`)
};

const nl_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen`)
};

const no_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salg`)
};

const pl_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promocje`)
};

const pt_br2_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções`)
};

const pt_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções`)
};

const ro_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reducerile`)
};

const fi_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alemukset`)
};

const sv_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reor`)
};

const vi_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá`)
};

const tr_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndirimler`)
};

const cs_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slevy`)
};

const bg_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промоции`)
};

const ru_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скидки`)
};

const uk_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розпродажі`)
};

const ar_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخفيضات`)
};

const hi_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेल`)
};

const th_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลดราคา`)
};

const ja_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セール`)
};

const zh_cn2_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`促销`)
};

const zh_hant1_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`促銷`)
};

const ko_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`할인`)
};

/**
* | output |
* | --- |
* | "Sales" |
*
* @param {Nav_SalesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_sales = /** @type {((inputs?: Nav_SalesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SalesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_sales(inputs)
	if (locale === "ms") return ms_nav_sales(inputs)
	if (locale === "da") return da_nav_sales(inputs)
	if (locale === "de") return de_nav_sales(inputs)
	if (locale === "en-US") return en_us2_nav_sales(inputs)
	if (locale === "es-ES") return es_es2_nav_sales(inputs)
	if (locale === "es-MX") return es_mx2_nav_sales(inputs)
	if (locale === "fil") return fil_nav_sales(inputs)
	if (locale === "fr") return fr_nav_sales(inputs)
	if (locale === "it") return it_nav_sales(inputs)
	if (locale === "hu") return hu_nav_sales(inputs)
	if (locale === "nl") return nl_nav_sales(inputs)
	if (locale === "no") return no_nav_sales(inputs)
	if (locale === "pl") return pl_nav_sales(inputs)
	if (locale === "pt-BR") return pt_br2_nav_sales(inputs)
	if (locale === "pt") return pt_nav_sales(inputs)
	if (locale === "ro") return ro_nav_sales(inputs)
	if (locale === "fi") return fi_nav_sales(inputs)
	if (locale === "sv") return sv_nav_sales(inputs)
	if (locale === "vi") return vi_nav_sales(inputs)
	if (locale === "tr") return tr_nav_sales(inputs)
	if (locale === "cs") return cs_nav_sales(inputs)
	if (locale === "bg") return bg_nav_sales(inputs)
	if (locale === "ru") return ru_nav_sales(inputs)
	if (locale === "uk") return uk_nav_sales(inputs)
	if (locale === "ar") return ar_nav_sales(inputs)
	if (locale === "hi") return hi_nav_sales(inputs)
	if (locale === "th") return th_nav_sales(inputs)
	if (locale === "ja") return ja_nav_sales(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_sales(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_sales(inputs)
	return ko_nav_sales(inputs)
});
export { nav_sales as "nav.sales" }